import type { Cart } from '@frontend/libs/types/cart'

import { create } from 'zustand'

type CartState = {
  isMiniCartOpen: boolean
  loading: boolean
} & Cart

type CartAction = {
  closeMiniCart: () => void
  openMiniCart: () => void
  setCart: (data: Cart) => void
}

const initialState: CartState = {
  coupons: [],
  errors: [],
  fees: [],
  isMiniCartOpen: false,
  itemCount: 0,
  items: [],
  loading: false,
  totals: {
    taxLines: [],
    totalDiscount: 0,
    totalDiscountTax: 0,
    totalFees: 0,
    totalFeesTax: 0,
    totalItems: 0,
    totalItemsTax: 0,
    totalPrice: 0,
    totalSaving: 0,
    totalShipping: 0,
    totalShippingTax: 0,
    totalTax: 0,
  },
}

export const useCartStore = create<CartAction & CartState>((set) => {
  const setCart = (data: Cart) => {
    set({
      ...data,
      loading: false,
    })
  }
  const openMiniCart = () => {
    set({ isMiniCartOpen: true })
  }
  const closeMiniCart = () => {
    set({ isMiniCartOpen: false })
  }

  return {
    ...initialState,
    closeMiniCart,
    openMiniCart,
    setCart,
  }
})
